export default "__VITE_ASSET__DesAVOq9__"